import { useMutation, MutationObserverOptions } from 'react-query';

import queryClient from 'clients/api/queryClient';
import FunctionKey from 'constants/functionKey';
import setInviter, { SetInviterInput, SetInviterOutput } from './setInviter';

type TrimmedSetInviterInput = Omit<SetInviterInput, 'userSigner'>;

export interface UseSetInviterInput extends TrimmedSetInviterInput {
  accountAddress: string;
}

type Options = MutationObserverOptions<SetInviterOutput, Error, UseSetInviterInput>;

const useSetInviter = (options?: Options) =>
  useMutation(
    FunctionKey.SET_INVITER,
    async (params: UseSetInviterInput) => {
      const { accountAddress, ...rest } = params;

      const { ethers } = await import('ethers');
      const provider = new ethers.providers.Web3Provider(window.ethereum as any);
      const userSigner = provider.getSigner();

      return setInviter({
        userSigner,
        ...rest,
      });
    },
    {
      ...options,
      onSuccess: (...onSuccessParams) => {
        queryClient.invalidateQueries(FunctionKey.GET_INVITER);

        if (options?.onSuccess) {
          options.onSuccess(...onSuccessParams);
        }
      },
    },
  );

export default useSetInviter;
